import React, { createContext, ReactElement, ReactNode } from 'react';

export const ChewyPortalContext = createContext<boolean | undefined>(undefined);

interface Props {
  enabled: boolean;
  children: ReactNode;
}

export const ChewyPortalProvider = ({ enabled, children }: Props): ReactElement => {
  return <ChewyPortalContext.Provider value={enabled}>{children}</ChewyPortalContext.Provider>;
};
